module.exports = __webpack_public_path__ + "static/media/bongoHi.3439a0ca.wav";